import axios from '@/axios'

export default {
  fetchLimit(params){
    return axios.get(`/activity-logs`, {params})
  },  
  fetchById(id){
    return axios.get(`/activity-logs/${id}`)
  }  
}